import { gql } from 'graphql-request';

import { batch } from '@distancify/drapejs-litium';
import { fetchPage } from '@drapejs/core';
import { defineReceiver } from '@drapejs/invoker';

import {
  getRelatedProductsCacheKey,
  hasRelationshipType,
} from '@/composables/useRelatedProductsBlock';
import { processBlocks } from '@/helpers/commandsHelper';
import { isProductPage } from '@/helpers/page-type';

import { getProductsSearchFields } from './category';

export const schedule = defineReceiver(
  fetchPage,
  async function (_command, data) {
    if (!isProductPage(data)) {
      return data;
    }

    await processBlocks(data, 'RelatedProducts', async (block) => {
      if (!hasRelationshipType(block)) {
        return;
      }

      const productIds: string[] =
        data.dataJson.product?.relatedProducts[
          block.fields?.RelationshipType?.value
        ] || [];

      const numOfProducts = block.fields.NumberOfProducts || 0;
      const limitedProductsIds = numOfProducts
        ? productIds.slice(0, numOfProducts)
        : productIds;

      await this.invoke(batch.scheduleQuery, {
        cacheKey: getRelatedProductsCacheKey(block),
        query: gql`
              elasticSearch{
                relatedProducts(productsIds: $productsIds){
                  ${getProductsSearchFields()}
                }
            }`,
        variables: {
          productsIds: {
            value: limitedProductsIds,
            type: '[Guid]!',
          },
        },
      });
    });

    return data;
  }
);
